/* The Google Ads conversion tag (27 Oct 2026): lets Google Ads see which searches and
   keywords brought a call, so the money goes to the ones that bring customers. Off until
   the platform setting GOOGLE_ADS has a tag id ("AW-…") - then the tag loads once and
   three things count as conversions:
     callback    a "Call me back" request sent
     call        a call to an owner or driver placed
     callToBook  "Call us to book" tapped (our own number)
   They ride on the analytics events the app already sends (utils/analytics track). */

const EVENT_CONVERSION = {
  callback_requested: "callback",
  call_placed: "call",
  call_to_book_tapped: "callToBook",
  trip_call_tapped: "callToBook",
};

let ads = null;          // { tagId, labels } once loaded and switched on
let loading = null;

function apiBase() {
  const raw = String(process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");
  return raw.endsWith("/api") ? raw : `${raw}/api`;
}

/** Fetches the setting and, when there is a tag id, adds Google's tag to the page. */
export function loadAdsTag() {
  if (loading) return loading;
  loading = fetch(`${apiBase()}/config/google-ads`)
    .then((r) => (r.ok ? r.json() : null))
    .then((j) => {
      const c = j?.data;
      if (!c?.tagId || typeof window === "undefined") return null;
      window.dataLayer = window.dataLayer || [];
      window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", c.tagId);
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(c.tagId)}`;
      document.head.appendChild(s);
      ads = c;
      return c;
    })
    .catch(() => null);
  return loading;
}

/** A conversion for an analytics event, when the tag is on and that action has a label. */
export function adsConversionFor(event) {
  const kind = EVENT_CONVERSION[event];
  const label = kind && ads?.labels?.[kind];
  if (!label || typeof window.gtag !== "function") return false;
  window.gtag("event", "conversion", { send_to: `${ads.tagId}/${label}` });
  return true;
}
